import * as React from 'react'
import {PasswordChangeState} from './PasswordChangeState'
import AppBar from 'material-ui/AppBar'
import NavigationMenu from 'material-ui/svg-icons/navigation/menu'
import IconButton from 'material-ui/IconButton'
import {PasswordChangeAction} from './PasswordChangeActions'
import TextField from 'material-ui/TextField'
import RaisedButton from 'material-ui/RaisedButton'
import injectSheet from 'react-jss'

interface Properties {
    readonly state: PasswordChangeState,
    readonly dispatch: (action: PasswordChangeAction) => void
}

const styles = {
    root: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column'
    },
    overviewWrapper: {
        overflowY: 'scroll',
        flex: '1'
    }
}

export const PasswordChange =
    injectSheet<Properties>(styles)(
        ({classes, state, dispatch}) => {
            const {input, validation} = state
            return (
                <div className={classes.root}>
                    <div className="navigation">
                        <AppBar
                            title="Passwort ändern"
                            className="navigation__bar"
                            iconElementLeft={
                                <IconButton
                                    onTouchTap={() =>
                                        dispatch({
                                            type: 'MenuButtonClicked',
                                        })}
                                >
                                    <NavigationMenu/>
                                </IconButton>}
                        />
                    </div>

                    <div className={`overview ${classes.overviewWrapper}`}>
                        <div
                            className="overview__content center"
                            style={{width: '60%'}}
                        >
                            <form
                                className="login__form"
                                onSubmit={(event) => {
                                    event.preventDefault()
                                    dispatch({
                                        type: 'Submit',
                                    })
                                }}
                            >
                                {state.status.type !== 'PasswordChanged' ?
                                    <p>
                                        <p>
                                            <TextField
                                                className="login__input"
                                                errorStyle={{
                                                    position: 'absolute',
                                                    bottom: '-15px'
                                                }}
                                                floatingLabelText="Aktuelles Passwort"
                                                fullWidth={true}
                                                type="password"
                                                errorText={validation.currentPassword === 'Mandatory' ?
                                                    'Pflichtfeld' :
                                                    state.status.type === 'PasswordWrong' ?
                                                        'Falsches Passwort' : null}
                                                value={input.currentPassword}
                                                onChange={(event, value) => dispatch({
                                                    type: 'OldPasswordChanged',
                                                    value
                                                })}
                                                autoFocus={true}
                                            />
                                            <TextField
                                                className="login__input"
                                                errorStyle={{
                                                    position: 'absolute',
                                                    bottom: '-15px'
                                                }}
                                                floatingLabelText="Neues Passwort"
                                                fullWidth={true}
                                                type="password"
                                                errorText={
                                                    validation.newPassword === 'Mandatory' ?
                                                        'Pflichtfeld' :
                                                        null}
                                                value={input.newPassword}
                                                onChange={(event, value) => dispatch({
                                                    type: 'NewPasswordChanged',
                                                    value
                                                })}
                                            />
                                            <TextField
                                                className="login__input"
                                                errorStyle={{
                                                    position: 'absolute',
                                                    bottom: '-15px'
                                                }}
                                                floatingLabelText="Neues Passwort wiederholen"
                                                fullWidth={true}
                                                type="password"
                                                value={input.newPasswordRepetition}

                                                errorText={validation.newPasswordRepetition === 'Mandatory' ?
                                                    'Pflichtfeld' :
                                                    validation.newPasswordRepetition === 'NotEqual' ?
                                                        'Wert muss mit dem Feld „Neues Passwort“ übereinstimmen' :
                                                        null}

                                                onChange={(event, value) => dispatch({
                                                    type: 'ConfirmationPasswordChanged',
                                                    value
                                                })}
                                            />
                                        </p>
                                        {state.status.type === 'GeneralError' &&
                                        <span className="login__network-error">
                                Netzwerkfehler
                            </span>}
                                        <br/>
                                        <p>
                                            <RaisedButton
                                                label="Passwort ändern"
                                                type="submit"
                                                primary={true}
                                                className="login__btn"
                                                disabled={state.status.type === 'Loading'}
                                            />
                                        </p>
                                    </p>
                                    :
                                    <p>
                                        Ihr Passwort wurde geändert.<br/>
                                        Bitte melden Sie sich fortan nur noch mit dem neuen
                                        Passwort an.
                                    </p>
                                }
                            </form>
                        </div>
                    </div>
                </div>
            )
        }
    )



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Pages/PasswordChange/PasswordChangeView.tsx